// ----------------------------------------------------------------------

import { Message as Response } from '@types'
import * as Base64 from 'base-64'

export const addMessageChunks = (dataObj: Response, value: string = ''): string => {
  //console.log('RECEIVED parts', dataObj['MessageSegment32KB']['payload'])
  return dataObj?.MessageSegment32KB?.payload ? value + Base64.decode(dataObj?.MessageSegment32KB?.payload) : value
}

export default addMessageChunks
